import React from 'react';
import ModelTop from '../../components/ModelTop';

export default function Chat() {
  return (
    <ModelTop
      title={'Chat Page'}
      src={'/video/website/chat.mp4'}
      para1={
        'this is a demonstration of how I enter the conversation with Gunchin and how I exit the conversation.\n In the middle of the message bar, there is a summary of the conversation with Gunchin generated by AI.'
      }
    ></ModelTop>
  );
}
